import classNames from 'classnames';
import * as React from 'react';

import css from './BooksCenteringUnderLineMessage.module.scss';

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  className?: string;
}

const BooksWithoutLoginAlert = ({ className, children }: Props) => {
  const classes = classNames(css.BooksCenteringUnderLineMessage, className);

  return (
    <div className={classes}>
      <p className={css.BooksCenteringUnderLineMessage__Paragraph}>
        {children}
      </p>
    </div>
  );
};

export default BooksWithoutLoginAlert;
